import axios from "axios";
import Api from "../Api/Api.json";

class ReportService {
  constructor() {
    this.baseURL = Api.UPSKILL_USER_API;
    this.headers = { "Content-Type": "application/json" };
  }

  async getReportCardSubjectProblemList(user_id, level, subject, medium) {
    const requestData = {
      task: "getReportCardSubjectProblemList",
      user_id: user_id,
      level: level,
      subject: subject,
      medium: medium,
    };
    const response = await axios.post(this.baseURL, requestData, {
      headers: this.headers,
    });
    return response.data;
  }

  async getSectionConceptSummaryReports(user_id, level, subject, medium, chapter, section) {
    const requestData = {
      task: "getSectionConceptSummaryReports",
      level: level,
      subject: subject,
      medium: medium,
      chapter: chapter,
      section: section,
      user_id: user_id,
    };
    console.log(requestData);
    const response = await axios.post(this.baseURL, requestData, {
      headers: this.headers,
    });
    console.log(response.data);
    return response.data;
  }

  async loadSubjectStats(user_id, level, subject, medium) {
    const requestData = {
      task: "getReportStat",
      user_id: user_id,
      level: level,
      subject: subject,
      medium: medium,
    };
    console.log(requestData);
    const response = await axios.post(this.baseURL, requestData, {
      headers: this.headers,
    });
    console.log(response.data);
    return response.data;
  }
}

export const reportService = new ReportService();
